module.exports = __webpack_public_path__ + "static/media/mv.3c896bfd.svg";